var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgQualification = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20.032,
    height: 25,
    viewBox: "0 0 20.032 25",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-ability-3734231",
    transform: "translate(-11.95 -2.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3822",
    "data-name": "Group 3822",
    transform: "translate(11.95 2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32486",
    "data-name": "Path 32486",
    d: "M31.548,6.312a.6.6,0,0,0,0-1.157L23.241,2.684A4.242,4.242,0,0,0,21.953,2.5a4.074,4.074,0,0,0-1.262.184L12.384,5.155a.6.6,0,0,0,0,1.157l3.181.946v2.865a1.325,1.325,0,0,0,.946,1.262l2.077.6a12.09,12.09,0,0,0,6.966,0l2.077-.6a1.325,1.325,0,0,0,.946-1.262V7.232L30.47,6.68V9.6h-.105a.263.263,0,0,0-.263.263v1.367a.263.263,0,0,0,.263.263h0l-.421.841a.25.25,0,0,0,.237.368H31.5a.266.266,0,0,0,.237-.368l-.421-.841h.053a.263.263,0,0,0,.263-.263V9.861a.263.263,0,0,0-.263-.263h-.105V6.443Z",
    transform: "translate(-11.95 -2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32487",
    "data-name": "Path 32487",
    d: "M52.348,52.1H43.41a.71.71,0,0,0,0,1.42h8.938a.707.707,0,0,0,.71-.71A.691.691,0,0,0,52.348,52.1Z",
    transform: "translate(-34.616 -39.061)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32488",
    "data-name": "Path 32488",
    d: "M22.061,46.183l-2.156,2.156-.815-.815a.706.706,0,1,0-1,1l1.341,1.341a.7.7,0,0,0,1,0l2.655-2.655a.683.683,0,0,0,0-1A.766.766,0,0,0,22.061,46.183Z",
    transform: "translate(-16.317 -34.563)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32489",
    "data-name": "Path 32489",
    d: "M52.348,70.1H43.41a.71.71,0,0,0,0,1.42h8.938a.71.71,0,1,0,0-1.42Z",
    transform: "translate(-34.616 -52.329)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32490",
    "data-name": "Path 32490",
    d: "M22.061,64.2l-2.156,2.156-.815-.815a.706.706,0,1,0-1,1l1.341,1.341a.7.7,0,0,0,1,0l2.655-2.655a.683.683,0,0,0,0-1A.693.693,0,0,0,22.061,64.2Z",
    transform: "translate(-16.317 -47.823)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32491",
    "data-name": "Path 32491",
    d: "M52.348,88.1H43.41a.71.71,0,1,0,0,1.42h8.938a.71.71,0,1,0,0-1.42Z",
    transform: "translate(-34.616 -65.597)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32492",
    "data-name": "Path 32492",
    d: "M22.061,82.253l-2.156,2.156-.815-.815a.706.706,0,1,0-1,1l1.341,1.341a.7.7,0,0,0,1,0l2.655-2.655a.683.683,0,0,0,0-1A.739.739,0,0,0,22.061,82.253Z",
    transform: "translate(-16.317 -61.144)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgQualification, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Qualification.3e8dd64b.svg";
export { ForwardRef as ReactComponent };